import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/car/task/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/car/task/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/car/task/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/car/task/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/car/task/update', params,options);

export const getAttachByMainIdList = (params, options) =>
  request.get('/api/v4ward/attach/getAttachByMainIdList', Object.assign({}, options, { params }));

// 获取所属部门下拉框数据
export const treeByProjectDeptId = (params, options) =>
  request.get('/api/v4ward/dept/treeByProjectDeptId', Object.assign({}, options, { params }));

  export const getDictionary = (code, options) =>
  request.get('/api/blade-system/dict/dictionary?code=' + code, Object.assign({}, options, {}));
// 获取列表
export const getProjectList = (params, options) =>
    request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

    export const getCarNoList = (params, options) =>
    request.get('/api/v4ward/car/task/getCarNo', Object.assign({}, options, { params }));
  
    export const getCarDetails = (params, options) =>
    request.get('/api/v4ward/car/task/getCarDetails', Object.assign({}, options, { params }));
    
    export const getDeptNameByUserId = (params, options) =>
    request.get('/api/v4ward/car/task/getDeptNameByUserId', Object.assign({}, options, { params }));
  
    export const getUseMileage = (params, options) =>
    request.get('/api/client/order/getUseMileage', Object.assign({}, options, { params }));
  
    
    